// extracted by mini-css-extract-plugin
module.exports = {"aboutMainDiv":"About_aboutMainDiv__1a4MG","aboutDiv":"About_aboutDiv__NS01C","aboutDivImg":"About_aboutDivImg__1zXl-","aboutDivText":"About_aboutDivText__1G5R3"};